<template>
  <div class="position-relative">
    <button
      ref="dropdown-container"
      @click="toggleMenu"
      type="button"
      :class="['btn dropdown-trigger', buttonClass]"
      :style="buttonStyle"
    >
      <p class="m-0 dropdown-title">{{ title }}</p>
      <i class="fa fa-chevron-right select-side-icon"></i>
    </button>
    <div :class="['menu-wrapper', { show: isOpen }]">
      <div class="dropdown-menu-container">
        <slot name="menu">
          <div
            v-for="(menu, index) in menus"
            :key="index"
            class="menu"
            @click="$emit('select', menu.value)"
          >
            {{ menu.title }}
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownButton",
  props: {
    buttonStyle: {
      type: Object,
      default: () => ({}),
    },
    buttonClass: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Select",
    },
    /**
     * Menus for dropdown
     * Array of objects with shape: { value: String, title: String }
     */
    menus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside(event) {
      if (
        this.$refs["dropdown-container"] &&
        !this.$refs["dropdown-container"].contains(event.target)
      ) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.select-side-icon {
  transform: rotate(90deg);
  color: #9f9f9f;
  font-size: 12px;
}

.dropdown-title {
  font-weight: 400;
  font-size: 14px;
  color: #2e364666;
}

.dropdown-trigger {
  border: 1px solid #cfd3d9;
  background: transparent;
  padding: 6px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.menu-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  max-height: 0px;
  overflow: hidden;
}

.menu-wrapper.show {
  max-height: 9999px;
}

.dropdown-menu-container {
  min-width: 10rem;
  height: auto;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  border-radius: 0.25rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.menu {
  padding: 8px 16px;
  font-size: 14px;
  color: #2e3646cc;
  cursor: pointer;
}

.menu:hover {
  background-color: #f8f9fa;
}
</style>


// WEBPACK FOOTER //
// src/components/Button/DropdownButton.vue